import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import '../../assets/css/Leads.css'

const AllManager = () => {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [workshops, setWorkshops] = useState([]);


  useEffect(() => {
    getLeadsData();
    getAdminData();
  }, []);

  const getAdminData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        "https://devapi.bykit.in/api/admin/workshop/list??type=live",
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('workshop', response)

      if (response.data && response.data.data) {
        setWorkshops(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const url = "https://devapi.bykit.in/api/admin/getallmanager??type=live"
    const payload = {
      user_id: 1
    }
    try {
      const response = await axios.post(url, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("All Managers:", response.data);

      if (response.data?.data) {
        setLeads(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.response?.data || error.message);
    }
  };


  const columns = [
    {
      name: "Date",
      cell: (row) => (
        <div>
          <p>{row.date || "N/A"}</p>
          <span className={`text-white font-bold ${row.status === 0 ? "deactvie_btn" : "active_btn"}`}>
            {row.status === 0 ? "Deactive" : "Active"}
          </span>
        </div>
      ),
      sortable: true
    },

    { name: "Name", selector: (row) => row.name || "N/A", sortable: true },
    { name: "Email", selector: (row) => row.email || "N/A", sortable: true },
    { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true },
  ];


  // --------------------------------filter------------------------------------
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
    const [filteredLeads, setFilteredLeads] = useState([]);
  
    const handleWorkshopSelect = (workshop) => {
      setSelectedWorkshop(workshop);
  
      console.log("Selected Workshop:", workshop);
      console.log("ID:", workshop.id);
  
  
      const matchedLeads = leads.filter((lead) => lead.parent_id === workshop.id);
      setFilteredLeads(matchedLeads);
  
      console.log("Filtered Leads:", matchedLeads);
    };



  return (
    <div className="container data-table-container p-2">
      {!showForm && (
        <div>
          <div className="d-flex align-items-center gap-3">
            <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
            </svg>

            <p className="m-0">All Managers</p>
          </div>
          <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
            <div>
              <h4 className='dashboard_head ps-3 pb-4'>All Managers</h4>
            </div>
            <hr></hr>
            <div className="d-flex justify-content-between mt-3 px-3">
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle dropdown_workshop text-light fw-bold"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedWorkshop ? selectedWorkshop.name : "Select Workshop"}
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {workshops.length > 0 ? (
                    workshops.map((workshop) => (
                      <li key={workshop.id}>
                        <button
                          className="dropdown-item "
                          onClick={() => handleWorkshopSelect(workshop)}>
                          {workshop.workshop}
                        </button>
                      </li>
                    ))
                  ) : (
                    <li>
                      <span className="dropdown-item">No Workshops Available</span>
                    </li>
                  )}
                </ul>
              </div>
              <div className="d-flex">
                <input
                  type="text"
                  placeholder="Search keyword"
                  className="search-input me-2"
                  style={{ padding: '8px' }}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

              </div>
            </div>

            <DataTable
              columns={columns}
              data={selectedWorkshop ? filteredLeads : leads}
              pagination
              responsive
              customStyles={{
                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                cells: {
                  style: {
                    padding: "5px",
                    margin: "0",
                  },
                },

                headCells: {
                  style: {
                    padding: "10px",
                    margin: "0",
                  },
                },
              }}
            />
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className='delete_text'>Are you sure, do you want to deactivate ?</p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={() => {
                // Call your function here
                console.log("Marked as Converted");
                setShowModal(false);
              }} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllManager;
